export const axiosOptions = {
  headers: { 'Content-Type': 'application/json', product: 'PORTAL' }
};
